var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemContentOutlined = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm0 2H5v14h14zM8.46 8.484a4.993 4.993 0 0 1 7.055 0A.999.999 0 1 1 14.1 9.898a2.99 2.99 0 0 0-4.226 0 2.993 2.993 0 0 0 0 4.227 2.99 2.99 0 0 0 4.226 0 .999.999 0 1 1 1.414 1.414 4.97 4.97 0 0 1-3.527 1.459 4.97 4.97 0 0 1-3.527-1.459 4.993 4.993 0 0 1 0-7.055"
})));
export default SvgGemContentOutlined;